export default {"src":"/_next/static/media/blue.c762c0a5.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};